// PUIU MAMEI — Main JS

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile menu ----
  const hamburger = document.querySelector('.nav-hamburger');
  const drawer = document.querySelector('.mobile-nav-drawer');
  const overlay = document.querySelector('.mobile-nav-overlay');
  const closeBtn = document.querySelector('.mobile-nav-close');

  function openMenu() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.classList.add('nav-open');
    hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.classList.remove('nav-open');
    hamburger.setAttribute('aria-expanded', 'false');
  }

  if (hamburger) {
    hamburger.addEventListener('click', openMenu);
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }
  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Close on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // ---- Newsletter form ----
  const newsletterInput = document.querySelector('.newsletter-input');
  const newsletterBtn = document.querySelector('.newsletter-btn');

  if (newsletterBtn) {
    newsletterBtn.addEventListener('click', function () {
      var email = newsletterInput.value.trim();
      if (email && email.includes('@')) {
        newsletterBtn.textContent = 'JOINED!';
        newsletterBtn.style.background = '#4caf50';
        newsletterBtn.style.color = '#fff';
        newsletterInput.value = '';
        setTimeout(function () {
          newsletterBtn.textContent = 'JOIN';
          newsletterBtn.style.background = '#fff';
          newsletterBtn.style.color = '#000';
        }, 3000);
      } else {
        newsletterInput.style.borderBottom = '2px solid red';
        setTimeout(function () {
          newsletterInput.style.borderBottom = '';
        }, 2000);
      }
    });
  }

  // ---- Smooth header shadow on scroll ----
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

});
